export const name = "SQRT";
export const summary = `Computes the square root of \`X\`.`;
export const reference = `
## SQRT

Computes the square root of \`X\`.

\`\`\`
SQRT(X)
\`\`\`

### Description

Computes the square root of X. Generates an error if X is less than 0.

| X | SQRT(X) |
| --- | --- |
| \`25.0\` | \`5.0\` |
| \`+inf\` | \`+inf\` |
| \`X < 0\` | Error |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
